import { axiosInstance } from 'utils/http';
import { flow } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-query';


export const useResumeCachedFlowRun = ({ crId, crFlowId, runId: initialRunId = '' }) => {
  const dispatch = useDispatch();
  const orgId = useSelector(state => state.session.user.primaryOrganization.organization.ID);
  const {
    isLoading,
    isError,
    isSuccess,
    mutate,
    mutateAsync,
    reset,
  } = useMutation(
    ['resume-flow-cached-run', orgId, crId, crFlowId, initialRunId],
    ({ pauseLevelID, runId: requestRunId = '' }) => {
      const runID = initialRunId || requestRunId;
      const payload = pauseLevelID ? { pauseLevelID } : {};

      return axiosInstance.post(flow(orgId).resumeCachedFlowRun(crId, crFlowId, runID), payload);
    },
    {
      onSuccess: () => {
        dispatch(showAlert({
          message: 'Flow Cached Run have been resumed.',
          type: 'success',
        }));
      },
      onError: (error) => dispatch(showAlert({
        message: error.response.data.message,
        type: 'error',
      })),
    },
  );
  return {
    isLoading,
    isError,
    isSuccess,
    mutate,
    mutateAsync,
    reset,
  };
};
